import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenant } from './contexts/TenantContext';

function Settings() {
  var navigate = useNavigate();
  var { tenant } = useTenant();

  var sections = [
    { icon: '🏢', title: 'Business Profile', desc: 'Name, address, phone, logo, and business details', path: '/app/business-settings' },
    { icon: '🔔', title: 'Reminders & Notifications', desc: 'Appointment reminders, SMS/email settings, templates', path: '/app/reminders' },
    { icon: '🕐', title: 'Staff Schedules', desc: 'Set working hours and availability for your team', path: '/app/schedule' },
    { icon: '💳', title: 'Billing & Plan', desc: 'Manage your subscription and payment method', path: '/app/billing' },
    { icon: '📥', title: 'Import Data', desc: 'Import customers, services, staff, or products from CSV', path: '/app/import' },
    { icon: '🔒', title: 'Change Password', desc: 'Update your login password', path: '/app/change-password' },
  ];

  return (
    <div style={{ padding: 32, maxWidth: 800, margin: '0 auto' }}>
      <h1 style={{ color: '#fff', fontSize: 28, fontWeight: 800, margin: '0 0 6px', letterSpacing: '-0.5px' }}>⚙️ Settings</h1>
      <p style={{ color: '#888', fontSize: 14, margin: '0 0 28px' }}>Manage your business configuration</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {sections.map(function(s) {
          return (
            <button
              key={s.path}
              onClick={function() { navigate(s.path); }}
              style={{
                background: '#12121f', border: '1px solid #1e1e35', borderRadius: 14,
                padding: '20px 24px', cursor: 'pointer', textAlign: 'left',
                display: 'flex', alignItems: 'center', gap: 16, transition: 'all 0.2s',
              }}
              onMouseEnter={function(e) { e.currentTarget.style.borderColor = '#ff6b2b'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={function(e) { e.currentTarget.style.borderColor = '#1e1e35'; e.currentTarget.style.transform = 'none'; }}
            >
              <div style={{ fontSize: 28, width: 48, textAlign: 'center', flexShrink: 0 }}>{s.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ color: '#fff', fontSize: 16, fontWeight: 700, marginBottom: 2 }}>{s.title}</div>
                <div style={{ color: '#888', fontSize: 13 }}>{s.desc}</div>
              </div>
              <span style={{ color: '#555', fontSize: 16 }}>→</span>
            </button>
          );
        })}
      </div>

      {tenant?.subdomain && (
        <div style={{ marginTop: 28, background: '#ff6b2b08', borderRadius: 14, border: '1px solid #ff6b2b15', padding: '20px 24px' }}>
          <div style={{ color: '#ff8f40', fontSize: 13, fontWeight: 700, marginBottom: 6 }}>Your Public Booking Page</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <code style={{ flex: 1, color: '#ccc', fontSize: 14, background: '#1a1c2e', padding: '8px 12px', borderRadius: 8 }}>
              ivisionmarketing.com/book/{tenant.subdomain}
            </code>
            <button
              onClick={function() { navigator.clipboard.writeText('https://ivisionmarketing.com/book/' + tenant.subdomain); }}
              style={{ background: '#ff6b2b', border: 'none', borderRadius: 8, padding: '8px 16px', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}
            >
              Copy
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Settings;
